import React from 'react';
import classnames from 'classnames/bind';
import { Button, UndoOutlinedIcon, RedoOutlinedIcon, IconButton } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './versionNavigation.module.scss';

const classNameBuilder = classnames.bind(styles);

export const VersionNavigation = ({
    currentIndex,
    totalVersions,
    hasPrevious,
    hasNext,
    onPrevious,
    onNext,
    disabled = false,
    isLoading = false,
}) => {
    const showNavigation = totalVersions > 1;

    if (!showNavigation) {
        return null;
    }

    return (
        <div className={classNameBuilder('container')}>
            <div className={classNameBuilder('version-info')}>
                <FormattedMessage
                    id="landing.pages.chat.version.indicator.compact"
                    defaultMessage="{currentVersion}/{totalVersions}"
                    values={{
                        currentVersion: currentIndex + 1,
                        totalVersions,
                    }}
                />
            </div>
            <div className={classNameBuilder('navigation-controls')}>
                <IconButton
                    className={classNameBuilder('nav-button')}
                    size={Button.size.xs}
                    variant={Button.variant.ghost}
                    onClick={onPrevious}
                    disabled={disabled || isLoading || !hasPrevious}
                    aria-label="Undo to previous version"
                    title={`Undo to version ${currentIndex} of ${totalVersions}`}
                >
                    <UndoOutlinedIcon />
                </IconButton>
                <IconButton
                    className={classNameBuilder('nav-button')}
                    size={Button.size.xs}
                    variant={Button.variant.ghost}
                    onClick={onNext}
                    icon={<RedoOutlinedIcon />}
                    disabled={disabled || isLoading || !hasNext}
                    aria-label="Redo to next version"
                    title={`Redo to version ${currentIndex + 2} of ${totalVersions}`}
                >
                    <RedoOutlinedIcon />
                </IconButton>
            </div>
        </div>
    );
};
